
    import { Vue, Component } from 'vue-property-decorator';

    @Component({
        components: {

        },
        props: {
            title: String,
            content: String,
            footer: String,
            yes: {
                type: String,
                default: 'Áno'
            },
            yesValue: {
                default: true
            },
            no: {
                type: String,
                default: 'Nie'
            },
            noValue: {
                default: false
            }
        }
    })
    export default class Confirm extends Vue{
    }
